export default {
  init: function () {
    const t = this
    t.scrollToTopButton = document.getElementById('js-top')

    if (!t.scrollToTopButton) return

    t.scrollFunc()

    t.scrollToTopButton.onclick = (e) => {
      e.preventDefault()
      t.scrollToTop()
    }
  },

  scrollFunc: function () {
    const t = this

    window.addEventListener('scroll', () => {
      let y = window.pageYOffset

      if (y > 500) {
        t.scrollToTopButton.setAttribute('data-top-arrow', '')
      } else {
        t.scrollToTopButton.removeAttribute('data-top-arrow')
      }
    })
  },

  scrollToTop: function() {
    const t = this
    const c = document.documentElement.scrollTop || document.body.scrollTop

    if (c > 0) {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  },
}
